<template>
    <div v-if="loading" class="loading-overlay">
        LOADING...
        <span class="loader"></span>
    </div>
    <div v-else>
        <h2 class="content-block">Dispatch - Container Status</h2>
        <TankStatusGrid :data-source="containers" :properties="properties" key-expr="containerId"
            :state-storage-key="storageKey" :default-column-config="defaultColumnConfig"
            :column-fixing-enabled="true" :height-offset="210" :use-default-column-config-only="false"
            @refresh-data="refreshData" @grid-initialized="setGridInstance" />
    </div>
</template>

<script>
import TankStatusGrid from '@/components/container/tank-status-grid.vue';

export default {
    components: {
        TankStatusGrid
    },
    created() {
        this.loadPageData();
    },
    data() {
        return {
            loading: true,
            dataGridInstance: null,
        };
    },
    computed: {
        storageKey() {
            return 'dispatch-containers-status';
        },
        defaultColumnConfig() {
            return {
                'operator': {
                    visible: true,
                    caption: 'Operator',
                    minWidth: 125,
                    alignment: 'left'
                },
                'area': {
                    visible: true,
                    caption: 'Area',
                    minWidth: 125,
                    alignment: 'left'
                },
                'devices': {
                    visible: true,
                    caption: 'Devices',
                    minWidth: 125,
                    alignment: 'left'
                },
                'surface': {
                    visible: true,
                    caption: 'Surface',
                    minWidth: 150,
                    alignment: 'left',
                    allowReordering: true
                },
            };
        },
        containers() {
            return this.$store.getters["dispatch/getContainers"];
        },
        properties() {
            return this.$store.getters["dispatch/getProperties"];
        },
    },
    methods: {
        setGridInstance(e) {
            this.dataGridInstance = e.component;
        },
        refreshData() {
            this.loadPageData();
        },
        async loadPageData() {
            this.loading = true;
            try {
                await this.$store.dispatch("dispatch/loadContainersStatus", { typeId: 1 });
            } catch (error) {
                this.error = error.message || "Unexpected Error.";
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
h2 {
    margin-left: 1em;
}
</style>
